var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCommunityFillSelected = function SvgCommunityFillSelected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_Community-Fill-Selected_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#292A2E",
    fillRule: "evenodd",
    d: "M20.5 14.46V4.892a2.4 2.4 0 0 0-.696-1.691 2.37 2.37 0 0 0-1.679-.701H3.875c-.63 0-1.234.252-1.68.7A2.4 2.4 0 0 0 1.5 4.893v9.568a2.4 2.4 0 0 0 .696 1.691c.445.449 1.05.701 1.679.701h3.563l3.207 3.23a.5.5 0 0 0 .71 0l3.207-3.23h3.563c.63 0 1.234-.252 1.68-.7a2.4 2.4 0 0 0 .695-1.692M5.063 7.284a1.2 1.2 0 0 1 .347-.846c.223-.224.525-.35.84-.35h9.5c.315 0 .617.126.84.35a1.2 1.2 0 0 1 0 1.692c-.223.224-.525.35-.84.35h-9.5c-.315 0-.617-.126-.84-.35a1.2 1.2 0 0 1-.348-.846m1.187 3.588c-.315 0-.617.126-.84.35a1.2 1.2 0 0 0 0 1.692c.223.224.525.35.84.35h3.563c.314 0 .617-.126.84-.35a1.2 1.2 0 0 0 0-1.692 1.18 1.18 0 0 0-.84-.35z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "_Community-Fill-Selected_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h22v22H0z"
  })))));
};
export default SvgCommunityFillSelected;